import { connect } from 'react-redux';

import Component from './StudentRoster.component';
import {
  initStudentsRoster,
  parseStudentDbToUi,
  uploadStudentRoster,
  getCurrentRosterYear,
} from './+store/studentRoster';
import {
  deleteStudentRequestCancel,
  deleteStudentConfirm,
  addStudentRequest,
  editStudentRequestCancel,
  addStudentRequestCancel,
  closeSnackbar,
  getAvatars,
  selectSnapshotYear,
  exportRoster,
  saveRosterStatCards,
} from './+store/studentRoster/studentRoster.actions';
import { campusDistrictInfo } from '../Settings/+store/SchoolSettings/SchoolSettings.selectors';
import { getClasslinkSettings, classlinkStateChanged } from '../Settings/+store/Integrations';

// The Accelerated Testers page is a district-level view (gated the same way the
// home-screen tile and side-nav are): only for districts / 9-12 campuses, and only
// when the district hasn't hidden the menu. Mirror that here so the roster shortcut
// never points at a route that isn't registered.
const canShowAcceleratedTesters = (state) => {
  const info = campusDistrictInfo(state);
  const isDistrictLevel = !!(info && (info.isDistrict || (info.gradeEnd && Number(info.gradeEnd) >= 9)));
  if (!isDistrictLevel) return false;
  const advanced = state.modules.Settings.advancedSettings.districtAdvancedSettings;
  const menusVisibility = (advanced && advanced.menusVisibility) || {};
  return menusVisibility.acceleratedTesters !== false;
};

const mapStateToProps = (state) => {
  let {
    roster,
    selectedSnapshotYear,
    selectedStudentToDelete,
    selectedStudentToEdit,
    rosterCSV,
    loadingCSV,
  } = state.modules.StudentRoster.studentRoster;
  const snapshotYear = selectedSnapshotYear || getCurrentRosterYear();
  roster = roster[snapshotYear];
  const deletingStudentId = selectedStudentToDelete;
  const editingStudentId = selectedStudentToEdit;
  const deletingStudent = deletingStudentId && roster ? roster[deletingStudentId] : null;
  const editingStudent = editingStudentId && roster ? roster[editingStudentId] : null;
  if (roster) {
    roster = Object.entries(roster).map(([id, student]) => [id, parseStudentDbToUi(student)]);
  } else {
    roster = [];
  }
  // Which summary stat cards to show is a per-user preference. Prefer the in-session choice
  // (visibleStatCards, set right after a save), then the persisted preference on the user's
  // profile, then null — the component falls back to its defaults when null.
  const userProfile = state.modules.Auth.auth.profile;
  const sessionStatCards = state.modules.StudentRoster.studentRoster.visibleStatCards;
  const savedStatCards =
    userProfile && userProfile.preferences && Array.isArray(userProfile.preferences.rosterStatCards)
      ? userProfile.preferences.rosterStatCards
      : null;
  const statCardKeys = sessionStatCards != null ? sessionStatCards : savedStatCards;
  return {
    roster,
    statCardKeys,
    snapshotYear,
    deletingStudentId,
    editingStudentId,
    deletingStudent,
    editingStudent,
    rosterCSV,
    loadingCSV,
    user: state.modules.Auth.auth.user,
    profile: state.modules.Auth.auth.profile,
    needsInit: state.modules.StudentRoster.studentRoster.needsInit,
    loadingMsg: state.modules.StudentRoster.studentRoster.loadingMsg,
    loading: !!state.modules.StudentRoster.studentRoster.loadingMsg,
    status: state.modules.StudentRoster.studentRoster.status,
    isAddingNewStudent: state.modules.StudentRoster.studentRoster.isAddingNewStudent,
    msg: state.modules.StudentRoster.studentRoster.msg,
    uploadedRoster: state.modules.StudentRoster.studentRoster.uploadedRoster,
    avatars: state.modules.StudentRoster.studentRoster.avatars,
    tags: state.modules.Settings.manageOrgTags.tags,
    showAcceleratedTesters: canShowAcceleratedTesters(state),
    classlinkConfig: state.modules.Settings.integrations.classlinkConfig,
    classlinkStatus: state.modules.Settings.integrations.classlinkState
      ? state.modules.Settings.integrations.classlinkState.status
      : null,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onDrop: (accepted, rejected, user, profile, year, removeStudentsNotInUpload) => {
    // dispatch(onRosterDrop(accepted, rejected, profile));
    dispatch(uploadStudentRoster(accepted, rejected, user, profile, year, removeStudentsNotInUpload));
  },

  getSelectedYearRoster: (user, year) => {
    dispatch(initStudentsRoster(user, year));
  },
  init: (user) => {
    dispatch(initStudentsRoster(user));
    dispatch(getAvatars());
  },
  cancelDelete: () => {
    dispatch(deleteStudentRequestCancel());
  },
  confirmDelete: (studentId, orgId, year) => {
    dispatch(deleteStudentConfirm(studentId, orgId, year));
  },
  handleAddStudentRequest: () => {
    dispatch(addStudentRequest());
  },
  handleCancelEdit: () => {
    dispatch(editStudentRequestCancel());
  },
  handleCancelAdd: () => {
    dispatch(addStudentRequestCancel());
  },
  handleMsgClose: () => {
    dispatch(closeSnackbar());
  },
  onSelectSnapshotYear: (year) => {
    dispatch(selectSnapshotYear(year));
  },
  handleRosterExport: (year) => {
    dispatch(exportRoster(year));
  },
  onSaveStatCards: (uid, cards) => {
    dispatch(saveRosterStatCards(uid, cards));
  },
  loadClasslinkConfig: () => {
    dispatch(getClasslinkSettings());
  },
  classlinkStateChanged: (liveState) => {
    dispatch(classlinkStateChanged(liveState));
  },
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
